import * as React from 'react';

import { LoadingIcon } from 'bones/design-system/components/icons/LoadingIcon';

export interface LoadingProps {
  'data-testid'?: never;
  className?: string;
  size: 'lg' | 'md' | 'sm';
  testId?: string;
}

export const Loading: React.VFC<LoadingProps> = ({
  className,
  size,
  testId,
}) => {
  if (size === 'lg') {
    return <LoadingIcon className={className} data-testid={testId} size={40} />;
  }
  if (size === 'md') {
    return <LoadingIcon className={className} data-testid={testId} size={24} />;
  }
  return <LoadingIcon className={className} data-testid={testId} size={16} />;
};
